<div class="wrapper">
	<!-- <button (click)="stockManager()">Stock manager</button> -->
	<!-- <button (click)="playClickSound()">sound</button> -->
	<app-manager-header
		[venue]=" venue$  | async"
		[showFaq]="true"
		[showChip]="true"
		[soundSwitcher]="true"
		[soundOn]="soundOn$$ | async"
		(toggleSound)="toggleSound($event)"
	></app-manager-header>
	<ng-container *ngIf="(showErroMessage$ | async) as errorValue">
		<div *ngIf="errorValue?.warning" class="warning">
			<img src="../../../assets/warning.jpg" alt />
			<div>
				<h3>
					Um eine pünktliche Lieferung mit UberDirect sicherzustellen, sollte
					der Foodspot umgehend auf „Bereit“ gesetzt werden, sobald alle
					Bestellungen fertig zubereitet sind.
				</h3>
				<p>
					Erst nach dem Klick auf „Bereit“ werden die Bestellungen an Uber
					übermittelt. Die Ankunft eines Uber-Fahrers dauert in der Regel etwa
					20–25 Minuten.
				</p>
			</div>
		</div>
		<div *ngIf="errorValue?.error" class="warning error">
			<img src="../../../assets/warning.jpg" alt />
			<div>
				<h3>
					Um eine pünktliche Lieferung mit UberDirect sicherzustellen, sollte
					der Foodspot umgehend auf „Bereit“ gesetzt werden, sobald alle
					Bestellungen fertig zubereitet sind.
				</h3>
				<p>
					Erst nach dem Klick auf „Bereit“ werden die Bestellungen an Uber
					übermittelt. Die Ankunft eines Uber-Fahrers dauert in der Regel etwa
					20–25 Minuten.
				</p>
			</div>
		</div>
	</ng-container>

	@if ((posStatus$$ | async) === false) {
	<div class="pos-intergration">
		<div class="pos-intergration__banner">
			<p class="pos-intergration__text">{{'posStatusInfo' | translate}}</p>
		</div>
	</div>
	}

	<app-table-list-draw></app-table-list-draw>
	<div class="order-filters-row">
		<app-order-type-filter></app-order-type-filter>
	</div>
	<div class="order-container" #scrollableContent>
		@for (order of (orders$ | async); track order?._id) {

		<app-manager-order-item-draw
			[order]="order"
			[loadingOrders]="loadingOrders"
			[selectedRed]="(showErroMessage$ | async)"
			[venue]="venue$ | async"
			[updateStatusLoading]="updateStatusLoading$ | async"
			(sendOrderPoolStatusChange)="updateStatusOrderPool($event)"
			(sendOrderStatusChange)="updateStatus($event)"
			(sendToPosOrder)="sendToPOSOrder($event)"
		>
		</app-manager-order-item-draw>

		}
	</div>
	<div class="nav-buttons">
		<button mat-icon-button class="scroll-btn left" (click)="scrollLeft()">
			<mat-icon>chevron_left</mat-icon>
		</button>
		<button mat-icon-button class="scroll-btn right" (click)="scrollRight()">
			<mat-icon>chevron_right</mat-icon>
		</button>
	</div>
</div>
